export default __webpack_public_path__ + "static/media/Mercari_logo_2018.svg.22cf542c.png";